import uuid from "react-uuid";
import AWS from "aws-sdk";

const rawServiceUrl =
  process.env.REACT_APP_SERVICE_URL ||
  process.env.REACT_APP_API_BASE ||
  "/api";
export const API_BASE = rawServiceUrl.replace(/\/+$/, "");
export const EMAIL_API_URL = process.env.REACT_APP_EMAIL_URL || process.env.REACT_APP_EAMIL_URL || "/email-api/sendemail";
export const API_KEY = process.env.REACT_APP_KEY || "";

export const API_HEADERS = {
  "Content-Type": "application/json",
  "x-api-key": API_KEY,
};

// Save new expense to the server
export const saveUser = async (user) => {
  try {
    user.id = uuid();
    user.type = "appusers";
    console.log(user);
    await fetch(`${API_BASE}/items`, {
      method: "POST",
      headers: API_HEADERS,
      body: JSON.stringify(user),
    });
    console.log("user saved");
  } catch (err) {
    console.log("Error saving expense: ", err);
    throw err;
  } finally {
    return 200;
  }
};

export const sendEmail = async (data) => {
  console.log("from service call start", data);

  const payload = {
    ...data,
    sender: data.sender || process.env.REACT_APP_SENDEREMAIL || "Pocket Apps <support@theuniquecreations.com>",
  };

  const isLocalDev = typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

  // In local development on localhost, attempt to use the local dev proxy if available
  if (isLocalDev) {
    try {
      const proxyRes = await fetch("/email-api/sendemail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const contentType = proxyRes.headers.get("content-type") || "";
      if (proxyRes.ok && !contentType.includes("text/html")) {
        console.log("Email sent successfully via local dev proxy");
        return { success: true };
      }
    } catch (proxyErr) {
      console.warn("Local proxy unavailable, falling back to direct SES endpoint", proxyErr);
    }
  }

  // Direct AWS SES endpoint:
  // Using mode 'no-cors' with 'text/plain' ensures:
  // 1. Browser treats this as a W3C Simple Request
  // 2. Skips OPTIONS preflight entirely (eliminates CORS errors on all domains)
  // 3. Delivers payload directly to AWS Lambda / SES without requiring Amplify rewrite rules
  try {
    await fetch(EMAIL_API_URL, {
      method: "POST",
      mode: "no-cors",
      headers: { "Content-Type": "text/plain" },
      body: JSON.stringify(payload),
    });

    console.log("Email dispatched successfully via SES");
    return { success: true };
  } catch (err) {
    console.error("No-cors send failed, attempting standard fetch:", err);
    try {
      const directRes = await fetch(EMAIL_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (directRes.ok) {
        console.log("Email sent successfully via standard fetch");
        return { success: true };
      }
      return { error: `HTTP ${directRes.status}` };
    } catch (finalErr) {
      console.error("All email delivery attempts failed:", finalErr);
      return { error: finalErr.message || "Failed to send email" };
    }
  }
};

// Save new expense to the server
export const UpdateUser = async (user) => {
  try {
    user.type = "appusers";
    console.log(user);
    await fetch(`${API_BASE}/items`, {
      method: "POST",
      headers: API_HEADERS,
      body: JSON.stringify(user),
    });
    console.log("user updaed");
  } catch (err) {
    console.log("Error saving user: ", err);
    throw err;
  } finally {
    return 200;
  }
};
export const UpdateData = async (user) => {
  try {
    console.log(user);
    await fetch(`${API_BASE}/items`, {
      method: "POST",
      headers: API_HEADERS,
      body: JSON.stringify(user),
    });
    console.log("user updaed");
  } catch (err) {
    console.log("Error saving user: ", err);
    throw err;
  } finally {
    return 200;
  }
};
export const addData = async (data) => {
  try {
    console.log(data);
    await fetch(`${API_BASE}/items`, {
      method: "POST",
      headers: API_HEADERS,
      body: JSON.stringify(data),
    });
    console.log("Item saved");
  } catch (err) {
    console.log("Error saving category: ", err);
    throw err;
  } finally {
    return 200;
  }
};

export const addExpenseCategory = async (data) => {
  try {
    console.log(data);
    await fetch(`${API_BASE}/items`, {
      method: "POST",
      headers: API_HEADERS,
      body: JSON.stringify(data),
    });
    console.log("category saved");
  } catch (err) {
    console.log("Error saving category: ", err);
    throw err;
  } finally {
    return 200;
  }
};
export const getExpenseCategory = async (email) => {
  try {
    console.log("Fetching data for email:", email);

    // Prepare the request body
    const requestBody = {
      column1: "email",
      value1: email,
      column2: "type",
      value2: "expense-category",
    };

    // Make a POST request to the Lambda endpoint
    const response = await fetch(`${API_BASE}/items/filter2column`, {
      method: "POST",
      headers: API_HEADERS,
      body: JSON.stringify(requestBody),
    });

    // Parse and return the filtered data
    const data = await response.json();
    return data || []; // Return items or an empty array if no items found
  } catch (err) {
    console.log("Error getting users:", err);
    return []; // Return an empty array on error
  }
};

// personal expense
export const getPersonalExpense = async (email) => {
  try {
    console.log("Fetching personal expense data for email:", email);

    // Prepare the request body
    const requestBody = {
      column1: "email",
      value1: email,
      column2: "type",
      value2: "expense",
    };

    // Make a POST request to the Lambda endpoint
    const response = await fetch(`${API_BASE}/items/filter2column`, {
      method: "POST",
      headers: API_HEADERS,
      body: JSON.stringify(requestBody),
    });

    const data = await response.json();
    const filteredData = data.filter((item) => item.expensetype === "personal");
    console.log("shared data", filteredData);
    return filteredData || [];
  } catch (err) {
    console.log("Error getting users:", err);
    return [];
  }
};
// Shared expenses used to be matched on the whole "a@x.com,b@y.com" string, so the
// same pair saved in a different order lost every row. Match on the set of members
// instead: ask for each member's expenses and keep the shared ones belonging to the
// same group, whatever order their sharedWith happens to be stored in.
const groupKeyOf = (value) =>
  Array.from(new Set(String(value || "").split(",").map((e) => e.trim().toLowerCase()).filter(Boolean)))
    .sort()
    .join(",");

export const getSharedExpense = async (sharedWith) => {
  const members = Array.from(new Set(String(sharedWith || "").split(",").map((e) => e.trim().toLowerCase()).filter(Boolean)));
  if (members.length === 0) return [];
  const groupKey = members.slice().sort().join(",");

  try {
    const perMember = await Promise.all(members.map((memberEmail) => getData(memberEmail, "expense").catch(() => [])));
    const seen = new Set();
    return perMember.flat().filter((row) => {
      if (!row || row.expensetype !== "shared" || seen.has(row.id)) return false;
      if (groupKeyOf(row.sharedWith) !== groupKey) return false;
      seen.add(row.id);
      return true;
    });
  } catch (err) {
    console.log("Error getting shared expenses:", err);
    return [];
  }
};

export const getExpenseHistory = async (email) => {
  try {
    console.log("Fetching expense data for email:", email);

    // Prepare the request body
    const requestBody = {
      column1: "email",
      value1: email,
      column2: "type",
      value2: "expense",
    };

    // Make a POST request to the Lambda endpoint
    const response = await fetch(`${API_BASE}/items/filter2column`, {
      method: "POST",
      headers: API_HEADERS,
      body: JSON.stringify(requestBody),
    });

    const data = await response.json();

    return data || [];
  } catch (err) {
    console.log("Error getting users:", err);
    return [];
  }
};
export const fetchUsers_old = async (email) => {
  try {
    console.log(email);
    const response = await fetch(`${API_BASE}/itemsbytype/appusers`, {
      headers: API_HEADERS,
    });
    ///items/{column}/{value}
    const data = await response.json();
    // Filter the user by email
    const user = data.find((user) => user.email === email);
    // Return the matched user or null if not found
    return user || null;
  } catch (err) {
    console.log("Error getting users: ", err);
    throw err; // Re-throw the error to handle it outside
  }
};

export const fetchUsers = async (email) => {
  try {
    console.log("Fetching user for email:", email);
    // Prepare the request body with filtering conditions
    const requestBody = {
      column1: "email",
      value1: email,
      column2: "type",
      value2: "appusers",
    };

    // Make a POST request to the Lambda endpoint
    const response = await fetch(`${API_BASE}/items/filter2column`, {
      method: "POST",
      headers: API_HEADERS,
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      console.warn(`fetchUsers response not ok: ${response.status} ${response.statusText}`);
      return null;
    }

    // Parse the JSON response
    const data = await response.json();
    if (Array.isArray(data)) {
      return data[0] || null;
    }
    return data || null;
  } catch (err) {
    console.log("Error getting users:", err);
    return null;
  }
};
export const deleteUser = async (id) => {
  try {
    const response = await fetch(`${API_BASE}/removeitem/${id}`, {
      method: "DELETE",
      headers: API_HEADERS,
    });

    if (!response.ok) {
      throw new Error("Failed to delete user.");
    }
    console.log("User deleted successfully:", id);
    return; // Return the response data if needed
  } catch (err) {
    console.log("Error deleting user:", err);
    throw err; // Re-throw the error to handle it in the calling function
  }
};
export const getData = async (email, type) => {
  try {
    console.log("Fetching personal expense data for email:", email);

    // Prepare the request body
    const requestBody = {
      column1: "email",
      value1: email,
      column2: "type",
      value2: type,
    };

    // Make a POST request to the Lambda endpoint
    const response = await fetch(`${API_BASE}/items/filter2column`, {
      method: "POST",
      headers: API_HEADERS,
      body: JSON.stringify(requestBody),
    });

    const data = await response.json();

    console.log(" data", data);
    return data || [];
  } catch (err) {
    console.log("Error getting users:", err);
    return [];
  }
};
export const deleteData = async (id) => {
  try {
    const response = await fetch(`${API_BASE}/removeitem/${id}`, {
      method: "DELETE",
      headers: API_HEADERS,
    });

    if (!response.ok) {
      throw new Error("Failed to delete user.");
    }
    console.log("data deleted successfully:", id);
    return; // Return the response data if needed
  } catch (err) {
    console.log("Error deleting user:", err);
    throw err; // Re-throw the error to handle it in the calling function
  }
};

export const getCurrency = (country) => {
  const countryCurrencyData = getCountryCurrency();
  const matched = countryCurrencyData.find((item) => item.country.toLowerCase() === (country || "").toLowerCase());
  return matched ? matched.currency : "";
};
export const getCountryCurrency = () => {
  return [
    { country: "United States", currency: "$", currencyName: "Dollar", code: "USD" },
    { country: "India", currency: "₹", currencyName: "Rupees", code: "INR" },
    { country: "Canada", currency: "CA$", currencyName: "Canadian Dollar", code: "CAD" },
    { country: "Australia", currency: "A$", currencyName: "Australian Dollar", code: "AUD" },
    { country: "Uruguay", currency: "$U", currencyName: "Uruguayan Peso", code: "UYU" },
    { country: "United Kingdom", currency: "£", currencyName: "Pound Sterling", code: "GBP" },
    { country: "Ireland", currency: "€", currencyName: "Euro", code: "EUR" },
    { country: "Mexico", currency: "$", currencyName: "Mexican Peso", code: "MXN" },
    { country: "Brazil", currency: "R$", currencyName: "Brazilian Real", code: "BRL" },
  ];
};
export const getItemsbyType = async (type) => {
  try {
    console.log(type);
    const response = await fetch(`${API_BASE}/itemsbytype/${type}`, {
      headers: API_HEADERS,
    });
    const data = await response.json();
    return data || null;
  } catch (err) {
    console.log("Error getting users: ", err);
    throw err;
  }
};
export const fetchRecipe = async (ingredients, cuisine) => {
  try {
    const response = await fetch(process.env.REACT_APP_AI_SERVICE_URL + "recepie-ai", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ingredients: ingredients,
        cuisine: cuisine,
      }),
    });

    if (!response) {
      throw new Error("Failed to fetch recipe data");
    }

    const data = await response.json();
    return data.recipe;
  } catch (error) {
    console.error("Error fetching recipe:", error);
    throw error;
  }
};
export const generateImage_usingBedrock = async (prompt) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_AI_SERVICE_URL}ai-image-generation-aws-bedrock`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        prompt,
        quality: "standard",
        cfgScale: 10.0,
        height: 512,
        width: 512,
        numberOfImages: 1,
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to generate image");
    }

    const data = await response.json();
    console.log("url generating image:", data.imageUrl);
    return data.imageUrl;
  } catch (error) {
    console.error("Error generating image:", error);
    throw error;
  }
};

export const uploadFileToS3 = async (imagename, file) => {
  imagename = process.env.REACT_APP_ENV + "-" + imagename;
  return new Promise((resolve, reject) => {
    const S3_BUCKET = process.env.REACT_APP_S3_BUCKET_NAME;
    const REGION = process.env.REACT_APP_S3_REGION;

    AWS.config.update({
      accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY.replace("RAMUK89", ""),
      secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY.replace("ramuk89", ""),
    });

    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: REGION,
    });

    const params = {
      Bucket: S3_BUCKET,
      Key: imagename,
      Body: file,
      ACL: "public-read", // Make file publicly readable
    };

    s3.putObject(params)
      .promise()
      .then(() => {
        const url = `${process.env.REACT_APP_S3_BUCKET_URL}/${imagename}`;
        resolve(url);
      })
      .catch((err) => {
        console.error("Error uploading to S3:", err);
        reject(err);
      });
  });
};

export const imagetoCaption = async (imageUrl) => {
  try {
    const response = await fetch(process.env.REACT_APP_AI_SERVICE_URL + "image-to-caption", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        imageUrl: imageUrl,
      }),
    });

    // Check if the response is successful
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data.caption; // Assuming the response contains a "caption" field
  } catch (error) {
    console.error("Error fetching caption:", error.message);
    throw error;
  }
};

export const formatRecipe = (text) => {
  const lines = text && text.split("\n");
  return (
    lines &&
    lines.map((line, index) => {
      // Bold the recipe name by replacing ~name~ with <strong>name</strong>
      let formattedLine = line.replace(/~(.*?)~/g, (match, p1) => `<h5><strong>${p1.replace(/"/g, "").trim()}</strong></h5>`);

      // Bold text within ** by replacing **text** with <strong>text</strong>
      formattedLine = formattedLine.replace(/\*\*(.*?)\*\*/g, (match, p1) => `<strong>${p1}</strong>`);

      if (line.startsWith("* ")) {
        // List items
        return (
          <small>
            <li className="text-small" key={index} dangerouslySetInnerHTML={{ __html: formattedLine.slice(2) }} />
          </small>
        );
      } else if (/^\d+\.\s/.test(line)) {
        // Numbered list items
        return <p key={index} dangerouslySetInnerHTML={{ __html: formattedLine }} />;
      } else {
        // Regular text or headings
        return <p key={index} dangerouslySetInnerHTML={{ __html: formattedLine }} />;
      }
    })
  );
};
